<style lang='postcss'>
  .boxShadow {
    transition: all 0.5s linear;
  }

  .boxShadow.notGreen::after {
    box-shadow: var(--leftShadow) var(--bottomShadow) var(--topShadow) #ff00f2, 0px var(--bottomShadow) var(--topShadow) #99318b, var(--rightShadow) var(--bottomShadow) var(--topShadow) #af326a;
  }

  .boxShadow.green::after {
    box-shadow: var(--leftShadow) var(--bottomShadow) var(--topShadow) #2bff47d9, 0px var(--bottomShadow) var(--topShadow) #319948, var(--rightShadow) var(--bottomShadow) var(--topShadow) #e9ff20;
  }

  .boxShadow::after {
    content: "";
    border-radius: 5px;
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    animation: changingOpacity 5s linear forwards infinite;
    --leftShadow: 5px;
    --rightShadow: -5px;
    --topShadow: 20px;
    --bottomShadow: 2.5px;
    transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  .boxShadow:hover::after, :global(.promoted::after) {
    --leftShadow: 10px;
    --rightShadow: -10px;
    --topShadow: 40px;
    --bottomShadow: 5px;
    opacity: 1;
  }

  @keyframes changingOpacity {
    0% {
      opacity: 0.6;
    }
    10% {
      opacity: 1;
    }
    20% {
      opacity: 0.4;
    }
    50% {
      opacity: 0.7;
    }
    100% {
      opacity: 0.6;
    }
  }

  .borderBottom {
    margin-bottom: 20px; padding-bottom:20px;
  }

  .borderBottom.notGreen {
    border-bottom: 1px solid #ec4899d9;
  }

  .borderBottom.green {
    border-bottom: 1px solid #2bff47d9;
  }

  .borderTop {
    margin-top: 20px; padding-top:20px;
  }

  .borderTop.notGreen {
    border-top: 1px solid #ec4899d9;
  }

  .borderTop.green {
    border-top: 1px solid #2bff47d9;
  }

  .instructions.notGreen {
    @apply text-pink-400;
  }

  .instructions.green {
    @apply text-green-400;
  }
  .instructions:hover {
    color: #da9cfb;
  }

  th, td,tbody {
    @apply bg-opacity-10 bg-black text-white !important;
  }

  th {
    @apply w-0;
  }

  td {
    @apply w-full;
  }

  html {
    scrollbar-face-color: #646464;
    scrollbar-base-color: #646464;
    scrollbar-3dlight-color: #646464;
    scrollbar-highlight-color: #646464;
    scrollbar-track-color: #000;
    scrollbar-arrow-color: #000;
    scrollbar-shadow-color: #646464;
    scrollbar-dark-shadow-color: #646464;
  }

  ::-webkit-scrollbar { width: 8px; height: 3px;}
  ::-webkit-scrollbar-button {  background-color: #da9cfb; }
  ::-webkit-scrollbar-track {  background-color: #646464;}
  ::-webkit-scrollbar-track-piece { background-color: #000;}
  ::-webkit-scrollbar-thumb { height: 50px; background-color: #da9cfb; border-radius: 3px;}
  ::-webkit-scrollbar-corner { background-color: #646464;}
  ::-webkit-resizer { background-color: #666;}
</style>

<!-- Aidrop -->

<div class='grid w-100' style='grid-template-columns: 100%; grid-template-rows: 100%; height: 60VH' in:fade="{{duration: 500}}">
  <div class='flex justify-around align-middle' style='height: 100%;'>
    <div class='relative rounded-xl h-full'>
      <div class='relative rounded-xl bg-black bg-opacity-20 boxShadow {eligibilityClass} h-full'>
        <div class="relative px-7 py-4 rounded-lg leading-none flex items-center divide-x divide-gray-600 w-full h-full">        
          <div class='flex w-full h-full flex-col items-center'>
            <!-- Airdrop Header -->
            <div class='w-full flex justify-center flex-wrap borderBottom {eligibilityClass}'>
              <h1 class='text-white text-4xl font-bold'>Airdrop</h1>
              <div class="text-white px-4 py-2 w-full flex justify-center">
                <b>/ ! \</b>&nbsp;&nbsp;<u>Limited to the first 1000 Registrants</u>&nbsp;&nbsp;<b>/ ! \</b>
              </div>
            </div>
            <!-- Instructions -->
            <div class="px-4 py-2 w-full flex flex-col justify-center items-center bg-black bg-opacity-10">
              <span class='text-2xl hover:scale-110 instructions {eligibilityClass} underline cursor modal-open'>INSTRUCTIONS</span>
              <ol class='text-white list-decimal mt-5'>
                <li>Add <a class='instructions' href='https://web.telegram.org/z/#5006556990'>@SolainuBot on Telegram</a></li>
                <li>Follow the instructions</li>
                <li>Claim</li>
              </ol>
            </div>
            <div class="flex justify-between w-full items-center text-center borderTop {eligibilityClass}">
            </div>
            <!-- Table -->
              <table class="table w-full table-compact overflow-y-scroll" style='display: inline-block !important;'>
                <thead>
                  <tr>
                    <th>#</th> 
                    <th>Address</th> 
                    <th>Email</th> 
                    <th>Multiplier</th> 
                  </tr>
                </thead>
                <tbody>
                  {#each rawData as data}
                    <tr>
                      <th>{rawData.indexOf(data) + 1}</th> 
                      <td>{data[0]}</td>
                      <td>{data[1]}</td>
                      <td>{data[2]}</td>
                    </tr>
                  {/each}
                </tbody>
              </table>
  
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Claim -->
  <div class='flex justify-around align-middle mt-5'>
    <div class='relative rounded-xl w-full'>
      <div class='relative rounded-xl bg-black bg-opacity-20 boxShadow {eligibilityClass}'>
        <div class="relative px-7 py-4 rounded-lg leading-none flex items-center divide-x divide-gray-600 w-full">
          <div class='flex w-full h-full flex-col items-center'>
            <div class="alert alert-{eligibilityClass == 'green' ? 'success' : 'error'}">
              <div class="flex-1 items-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="w-6 h-6 mx-2 stroke-current">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>                          
                </svg> 
                <label>{eligibilityClass == 'green' ? 'You are green. Claim here in 7 days.' : 'Your Address is Nnot in the Airdrop List'}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<script>
    import {fade, blur, fly, slide, scale, draw, crossfade} from 'svelte/transition'
    import Link from './../components/link.svelte';
    import { connected } from './../stores.js';
    import { onMount } from 'svelte';
    import { walletData } from './../stores.js';

    $: claimText = (($connected && $walletData['address']) ? checkAddressEligibility() : 'Log In to check Eligibility');
    $: eligibilityClass = 'notGreen'

    let rawData = [];

    function checkAddressEligibility() {
      if(!!JSON.stringify(rawData).match($walletData['address']) || !!JSON.stringify(rawData).toLowerCase().match($walletData['address'])) {
        eligibilityClass = 'green';
        return 'You are green. Claim here in 7 days.';
      }
      else {
        if(eligibilityClass == 'green') {
          return 'You are green. Claim here in 7 days.';
        }
        else {
          eligibilityClass = 'notGreen';
          return 'Your Address is Nnot in the Airdrop List';
        }
      }
    }
    onMount(async function() {
      const response = await fetch("https://raw.githubusercontent.com/ZeroXPingu/airdrop/master/data.json", {cache: "reload"});
      rawData = await response.json();
      if ($connected) {
        checkAddressEligibility();
      }
    });
</script>
